"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configure = require("../configure");
function endOfDecade(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 10);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function endOfCentury(date) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + 100);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}
function getLocalizers(globalize) {
    var locale = function (culture) { return culture ? globalize(culture) : globalize; };
    var date = {
        formats: {
            date: { date: 'short' },
            time: { time: 'short' },
            default: { datetime: 'medium' },
            header: 'MMMM yyyy',
            footer: { date: 'full' },
            weekday: 'eee',
            dayOfMonth: 'd',
            month: 'MMM',
            year: 'yyyy',
            decade: function (dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format(endOfDecade(dt), l.formats.year, culture);
            },
            century: function (dt, culture, l) {
                return l.format(dt, l.formats.year, culture) + " - " + l.format(endOfCentury(dt), l.formats.year, culture);
            }
        },
        startOfWeek: function (culture) {
            var date = new Date();
            // cldr-data doesn't seem to be zero based
            var localeDay = Math.max(parseInt(locale(culture).formatDate(date, { raw: 'e' }), 10) - 1, 0);
            return Math.abs(date.getDay() - localeDay);
        },
        parse: function (value, format, culture) {
            format = typeof format === 'string' ? { raw: format } : format;
            return locale(culture).parseDate(value, format);
        },
        format: function (value, format, culture) {
            format = typeof format === 'string' ? { raw: format } : format;
            return locale(culture).formatDate(value, format);
        }
    };
    var number = {
        formats: {
            default: { maximumFractionDigits: 0 }
        },
        // TODO major bump consistent ordering
        parse: function (value, culture) {
            return locale(culture).parseNumber(value);
        },
        format: function (value, format, culture) {
            if (value == null) {
                return value;
            }
            if (format && format.currency) {
                return locale(culture).formatCurrency(value, format.currency, format);
            }
            return locale(culture).formatNumber(value, format);
        },
        decimalChar: function (format, culture) {
            var str = this.format(1.1, { raw: '0.0' }, culture);
            return str[str.length - 2] || '.';
        },
        precision: function (format) {
            return !format || format.maximumFractionDigits == null ? null : format.maximumFractionDigits;
        }
    };
    var message = {
        // eslint-disable-next-line @typescript-eslint/ban-types
        formatMessage: function (path, variables, culture) {
            return locale(culture).formatMessage(path, variables);
        }
    };
    return { date: date, number: number, message: message };
}
function globalizeLocalizers(globalize) {
    var localizers = getLocalizers(globalize);
    configure.setLocalizers(localizers);
    return localizers;
}
exports.default = globalizeLocalizers;
